import withReducer from '@Hooks/withReducer';

import { reducer } from './ResultsPaginationReducer';
import { resultPaginationReducerKey } from './ResultsPaginationConstants';
import ResultsPagination from './ResultsPagination';

export default withReducer(resultPaginationReducerKey, reducer)(ResultsPagination);
